import React from "react";
import { Button, Checkbox, Form, Input, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  loading: boolean;
  form: any;
}

const CodeFormModal: React.FC<Props> = ({
  visible,
  onCancel,
  onSubmit,
  loading,
  form,
}) => {
  const { t } = useTranslation("docProcessingCodes");
  const { t: tCommon } = useTranslation("common");
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      title={t("codeFormModal.title")}
      width={800}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label={t("codeFormModal.titleLabel")}
          name="codeName"
          rules={[{ required: true, message: t("codeFormModal.nameRequired") }]}
        >
          <Input placeholder={t("codeFormModal.namePlaceholder")} />
        </Form.Item>
        <Form.Item label={t("codeFormModal.descriptionLabel")} name="codeDescription">
          <Input.TextArea
            maxLength={100}
            showCount
            placeholder={t("codeFormModal.descriptionPlaceholder")}
          />
        </Form.Item>
        <Form.Item label={t("codeFormModal.subcodeNameLabel")} name="subCodeName">
          <Select mode="multiple" placeholder={t("codeFormModal.subcodeNamePlaceholder")} />
        </Form.Item>
        <div className="codeSettingsContainer">
          <div className="checkboxContainer">
            <Form.Item name="codeWeightCheckbox">
              <Checkbox>{t("codeFormModal.enableWeighting")}</Checkbox>
            </Form.Item>
            <Form.Item name="decimalWeightCheckbox">
              <Checkbox>{t("codeFormModal.allowDecimalWeight")}</Checkbox>
            </Form.Item>
          </div>
          <div className="inputContainer">
            <Form.Item label={t("codeFormModal.weightMinLabel")} name="codeWeight">
              <Input type="number" placeholder={t("codeFormModal.weightMinPlaceholder")} />
            </Form.Item>
            <Form.Item label={t("codeFormModal.weightMaxLabel")} name="decimalWeight">
              <Input type="number" placeholder={t("codeFormModal.weightMaxPlaceholder")} />
            </Form.Item>
          </div>
        </div>
        <div className="buttonContainer">
          <Button onClick={onCancel}>{tCommon("cancel")}</Button>
          <Button type="primary" onClick={onSubmit} loading={loading}>
            {tCommon("submit")}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CodeFormModal;
